import {ScreenLockService} from '../../core/services/screenLockService/screenLock.service';

export class ReturningUserInfoController {
    public static $inject = ['screenLockService'];

    constructor(private screenLockService: ScreenLockService) {
        this.activate();
    }

    private activate(): void {
        this.screenLockService.broadcast(0);
    }
}